import {
  ref,
  toRef,
} from "vue";

import AHttpAPI from "aloha-vue/src/compositionAPI/AHttpAPI";

import {
  forEach,
} from "lodash-es";

export default function TemplatesAPI(props) {
  const template = toRef(props, "template");

  const templatesLoading = ref(false);
  const templateDownloadData = ref([]);

  const {
    getHttp,
  } = AHttpAPI();

  const initTemplates = () => {
    if (!template.value ||
      !template.value.obj_url ||
      !template.value.obj_id) {
      return;
    }
    
    templatesLoading.value = true;
    getHttp({
      url: `${ template.value.obj_url }/${ template.value.obj_id }/templates/`,
    }).then(
      response => {
        const TEMPLATE_DATA = [];
        forEach(response, value => {
          TEMPLATE_DATA.push({
            url: `${ template.value.obj_url }/${ template.value.obj_id }/render_template/?tpl=${ value.id }`,
            label: value.bez,
            title: `${ value.bez } herunterladen`,
          });
        });
        templateDownloadData.value = TEMPLATE_DATA;
      }
    ).finally(
      () => templatesLoading.value = false
    );
  };

  return {
    initTemplates,
    templateDownloadData,
    templatesLoading,
  };
}
